export default "__VITE_ASSET__DcxfIpA0__"